// © Microsoft Corporation. All rights reserved.

function setBodyUserSelect(value: string) {
    document.body.style["-webkit-touch-callout"] = value;
    document.body.style["-webkit-user-select"] = value;
    document.body.style["-khtml-user-select"] = value;
    document.body.style["-moz-user-select"] = value;
    document.body.style["-ms-user-select"] = value;
    document.body.style["user-select"] = value;
}

function preventSelection(e) {
    setBodyUserSelect("none");

    const removeNoSelect = () => setBodyUserSelect("unset");

    document.body.addEventListener("click", removeNoSelect, {once: true});
    document.body.addEventListener("mouseup", removeNoSelect, {once: true});
    document.body.addEventListener("touchend", removeNoSelect, {once: true});
}

function getPointerCoordinatesByEvent(e) {
    let coords;
    if (e.type == "touchstart" || e.type == "touchmove" || e.type == "touchend" || e.type == "touchcancel") {
        const evt = (typeof e.originalEvent === "undefined") ? e : e.originalEvent;
        const touch = evt.touches[0] || evt.changedTouches[0];
        coords = {x: touch.clientX, y: touch.clientY};
    } else if (e.type == "mousedown" || e.type == "mouseup" || e.type == "mousemove" || e.type == "mouseover"|| e.type=="mouseout" || e.type=="mouseenter" || e.type=="mouseleave") {
        coords = {x: e.clientX, y: e.clientY};
    }

    return coords;
}

function isPointerOnElement(e: Event, el: HTMLElement) {
    if (!e || !el) { return; }

    const rect = el.getBoundingClientRect();
    const pointerCoords = getPointerCoordinatesByEvent(e);
    return rect.left <= pointerCoords.x && rect.right >= pointerCoords.x && rect.top <= pointerCoords.y && rect.bottom >= pointerCoords.y;
}

export {preventSelection, getPointerCoordinatesByEvent, isPointerOnElement};